import type { MicState } from '@harmony/live-client'

/** Check if setSinkId is supported (Chrome, Edge, Opera - not Safari/Firefox) */
export const isSinkIdSupported =
    typeof HTMLMediaElement !== 'undefined' &&
    typeof (HTMLMediaElement.prototype as HTMLMediaElement & { setSinkId?: unknown }).setSinkId ===
        'function'

/** Check if popup has anything useful to show (2+ mic devices to switch between, speaker support, or error) */
export function shouldShowMicPopup(micState: MicState | undefined): boolean {
    if (!micState) {
        return false
    }
    const hasMicDevices = (micState.devices?.length ?? 0) >= 2
    return hasMicDevices || isSinkIdSupported || !!micState.error
}
